import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { useNavigate, Navigate } from "react-router-dom";

export default function Login() {
    const { user, login } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (e) {
            setErr("Invalid credentials. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-[80vh] flex items-center justify-center px-6 py-20">
            <div className="w-full max-w-md">
                <div className="eyebrow text-[#B8860B] mb-4 text-center">Studio Access</div>
                <h1 className="font-serif text-4xl md:text-5xl text-center mb-12 tracking-tight">Admin Sign In</h1>
                <form onSubmit={submit} className="space-y-8">
                    <div>
                        <label className="block eyebrow text-black/60 mb-2 text-[10px]">Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            data-testid="admin-email-input"
                            className="w-full border-b border-black/30 focus:border-[#D4AF37] outline-none py-3 bg-transparent"
                        />
                    </div>
                    <div>
                        <label className="block eyebrow text-black/60 mb-2 text-[10px]">Password</label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="admin-password-input"
                            className="w-full border-b border-black/30 focus:border-[#D4AF37] outline-none py-3 bg-transparent"
                        />
                    </div>
                    {err && <p data-testid="admin-login-error" className="text-red-700 text-sm">{err}</p>}
                    <button type="submit" disabled={loading} data-testid="admin-login-submit" className="kind-btn-primary w-full justify-center">
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </form>
            </div>
        </div>
    );
}
